import styled from "styled-components";
import { borderBottom1px } from "../../utils/style/mixin";

const Container = styled.div`
  .Yep-tabs-tab-bar-wrap {
    position: fixed;
    z-index: 20;
    bottom: 0;
    width: 100%;
    height: 1rem;
    background-color: #fff;
  }
  .Yep-tabs.iphonex .Yep-tabs-tab-bar-wrap{
    height: 1.34rem;
  }
  .Yep-tabs-default-bar-tab {
    height: 1rem;
    line-height: unset;
  }
  .Yep-tabs-default-bar-content {
    width: 100%;
    height: 1rem;
    color: #8c8c8c;
  }
  .Yep-tabs-default-bar-content:before {
    content: none !important;
  }
  .Yep-tabs-default-bar-tab-active {
    color: #262626;
    font-weight: bold;
  }

  .tab-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.2rem;

    position: fixed;
    bottom: 0;
    width: 33.33%;
    height: 1rem;
    background-color: #fff;
    z-index: 99;

  }
  .Yep-tabs.iphonex .tab-wrap{
    height: 1.34rem;
  }
  .iphonex.tab-wrap{
    height: 1.34rem;
  }
  .index-txt{
    color:#8c8c8c;
  }
  .tab-icon {
    width: 0.44rem;
    height: 0.44rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    margin-bottom: 0.08rem;
  }
  .tab-wrap .pcqq {
    background-image: url(//m.360buyimg.com/img/jfs/t1/70556/8/18090/1530/627b6897E9bb84851/f6d1d1bb97c2f82e.png);
  }
  .tab-wrap .pochanbdw,
  .tab-wrap .zichanbdw {
    background-image: url(//m.360buyimg.com/img/jfs/t1/80062/5/18258/2168/627b69bcE4f81bdef/19e7cc4181622f54.png);
  }
  .tab-wrap .tzrzm {
    background-image: url(//m.360buyimg.com/img/jfs/t1/186110/8/24782/3259/627b6a47Ef3bdd84f/f79a0645c2394a50.png);
  }
  .tab-wrap .jgxp {
    background-image: url(//m.360buyimg.com/img/jfs/t1/88224/1/28211/1822/627b6a8fEc278cb5e/c2d8872e1c771c1b.png);
  }
  .tab-wrap .zccz {
    background-image: url(//m.360buyimg.com/img/jfs/t1/100738/37/21790/2320/627b6d8eE15d268ce/121fa4f4fe547fda.png);
  }
  .tab-wrap .zctj {
    background-image: url(//m.360buyimg.com/img/jfs/t1/105576/39/28273/2756/627b6e56Ed829080d/b6303ce1cf41ef6f.png);
  }
  .tab-wrap .czgg {
    background-image: url(https://img11.360buyimg.com/imagetools/jfs/t1/242123/19/25114/1785/67492114F110e7a81/897e6c486f28d5ba.png);
  }
  .Yep-tabs-default-bar-tab-active .tab-wrap .pcqq {
    background-image: url(//m.360buyimg.com/img/jfs/t1/159375/25/22420/1458/627b68efEe09e9e55/f8e59c82b0815ccb.png);
  }
  .Yep-tabs-default-bar-tab-active .tab-wrap .pochanbdw,
  .Yep-tabs-default-bar-tab-active .tab-wrap .zichanbdw {
    background-image: url(//m.360buyimg.com/img/jfs/t1/124204/1/21964/1665/627b69f9Ecf438e47/82e8dccac34886d5.png);
  }
  .Yep-tabs-default-bar-tab-active .tab-wrap .tzrzm {
    background-image: url(//m.360buyimg.com/img/jfs/t1/25809/32/16316/2183/627b6a5dE347f5a6e/fd665e9f5f00d4f9.png);
  }
  .Yep-tabs-default-bar-tab-active .tab-wrap .jgxp {
    background-image: url(//m.360buyimg.com/img/jfs/t1/97755/12/30075/1350/627b6abbE36a5d1c9/4edae13bfdf8272f.png);
  }
  .Yep-tabs-default-bar-tab-active .tab-wrap .zccz {
    background-image: url(//m.360buyimg.com/img/jfs/t1/128948/25/28475/1916/627b6da8E4920a7ff/0c0df1c39464e886.png);
  }
  .Yep-tabs-default-bar-tab-active .tab-wrap .zctj {
    background-image: url(//m.360buyimg.com/img/jfs/t1/201901/19/22642/2277/627b6e6fE768b7c14/df814f4551693ac9.png);
  }
  .Yep-tabs-default-bar-tab-active .tab-wrap .czgg {
    background-image: url(https://img13.360buyimg.com/imagetools/jfs/t1/203186/15/51658/1555/6745b6b0Fbc000188/774af194159a45e7.png);
  }

  .search-area {
    position: absolute;
    top: 0;
    z-index: 10;
    width: 100%;
  }

  .operation-card {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    background-color: #fff;
    padding: 0.4rem 0;
  }

  .filter-bar {
    position: relative;
    top: -2px;
    .filter-block {
      width: 100%;
      height: 1.2rem;
    }
    .filter-block.jdapp-filter-block{
      height: 1.2rem;
    }
  }

  .fixed-area {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }

  .padding-top-area {
    padding-top: 2.24rem;
  }

  .Yep-tabs-default-bar-tab{
    width:33.33%;
  }
`;

const Empty = styled.div`
display: flex;
flex-direction: column;
align-items: center;
width: 100%;
height: 15rem;
text-align: center;
padding-top: 2rem;
background-color: #fff;
img {
width: 3rem;
height: 3rem;
}
p {
font-family: PingFangSC-Regular;
	font-size: 0.3rem;
	line-height: 0.44rem;
	color: #bfbfbf;
}
`;

export { Container, Empty };
